import { Filmomtale } from '@filmweb/sanity-types';
import classNames from "classnames";
import CMSImage from 'components/images/Image';
import SNoPoster from "components/NoPoster";
import isKinoklubb from 'lib/isKinoklubb';
import { getFilmUrlFromEdi, IMovieArticle } from 'lib/types/sanity';
import Link from "next/link";
import styles from "./MoviePoster.module.css";


//#region [Props]


type MoviePosterProps = {
    className?: string;
    filmomtale?: Filmomtale | null;
    sizes?: string;
    label?: string;
    fallbackTitle?: string;
    edi: string;
    fwpakkeFilmomtale?: IMovieArticle;
    allowTitleOverride?: boolean;
};
//#endregion

//#region [Component]
export default function MoviePoster({ className, edi, fallbackTitle, label, fwpakkeFilmomtale, filmomtale, allowTitleOverride = false, sizes = "(min-width: 1440px) 270px, 116px" }: MoviePosterProps) {
    const poster = filmomtale?.mainPosterV2 ?? filmomtale?.postersV2?.[0];
    let title = filmomtale?.title ?? fallbackTitle;
    if (allowTitleOverride && fwpakkeFilmomtale?.titleOverride) {
        title = fwpakkeFilmomtale?.titleOverride;
    }

    return <Link href={getFilmUrlFromEdi(filmomtale?.mainVersionEDI ?? edi)} >
        <div className={classNames(styles.SPosterContainer, !!filmomtale && isKinoklubb(filmomtale) ? styles.SPosterContainer_isKinoklubb : null, className)}>
            {poster && <CMSImage className={styles.SPosterImage} image={poster} sizes={sizes} isFilmweb altText={`Plakat for '${filmomtale?.title}'`} crop isPosterAspect />}
            {!poster && <SNoPoster />}
        </div>
        <div className={styles.STextContainer}>
            {label && <div className={styles.SPosterLabel}>{label}</div>}
            <h1 className={styles.SMovieTitle}>{title}</h1>
        </div>
    </Link>;
}
//#endregion